import getIPRange from 'get-ip-range';
import CIDR from 'cidr-js';

const formatIPInput = result => {
  const cidr = new CIDR();
  return result
    .split(/\r?\n/)
    .filter(item => item.trim() !== '')
    .map(item => item.trim())
    .map(item => {
      if (item.includes('~')) {
        return cidr.getBlocks(
          getIPRange(
            item
              .split('~')
              .map(item => item.trim())
              .join('-')
          )
        );
      } else if (item.includes('*')) {
        return cidr.getBlocks(
          getIPRange(item.replace('*', '1'), item.replace('*', '255'))
        );
      } else {
        return item;
      }
    })
    .flat();
};

export default formatIPInput;
